<mat-card>
  <mat-card-header class="between">
    <mat-card-title style="margin: 0">Tow List</mat-card-title>
    <button
      mat-flat-button
      routerLink="/tows/create"
      [checkPermission]="['recordingEvent', 'edit']"
    >
      Create
    </button>
  </mat-card-header>
  <mat-card-content>
    <table
      mat-table
      [dataSource]="dataSource$"
      matSort
      matSortDisableClear
      matSortActive="updatedAt"
      matSortDirection="desc"
    >
      <ng-container matColumnDef="metadata.oldTowBaseId">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            ID
          }
        </th>
        <td mat-cell *matCellDef="let item">{{ item.metadata?.oldTowBaseId }}</td>
      </ng-container>

      <ng-container matColumnDef="metadata.ship.name">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Ship
          }
        </th>
        <td mat-cell *matCellDef="let item">{{ item.metadata?.ship?.name }}</td>
      </ng-container>

      <ng-container matColumnDef="metadata.status">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Status
          }
        </th>
        <td mat-cell *matCellDef="let item">
          @if (item.metadata?.status) {
            <app-status-chip [value]="item.metadata.status" />
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="metadata.year">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Date
          }
        </th>
        <td mat-cell *matCellDef="let item">
          @if (item.metadata?.month) {
            {{ towsService.toDate(item) | date: 'MMM' : 'UTC' }}
          }
          @if (item.metadata?.year) {
            {{ towsService.toDate(item) | date: 'y' : 'UTC' }}
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="metadata.validity">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Validity
          }
        </th>
        <td mat-cell *matCellDef="let item">{{ item.metadata?.validity }}</td>
      </ng-container>

      <ng-container matColumnDef="metadata.message">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Comment
          }
        </th>
        <td mat-cell *matCellDef="let item">{{ item.metadata?.message }}</td>
      </ng-container>

      <ng-container matColumnDef="updatedAt">
        <th mat-header-cell mat-sort-header *matHeaderCellDef>
          @if (!isLoading) {
            Last Updated
          }
        </th>
        <td mat-cell *matCellDef="let item">{{ item.updatedAt | date: 'dd/MM/y' : 'UTC' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headings"></tr>
      <tr
        mat-row
        class="row clickable"
        [class.hidden]="isLoading"
        *matRowDef="let row; columns: headings"
        [routerLink]="row._id"
      ></tr>

      <tr class="mat-row" *matNoDataRow [hidden]="isLoading">
        <td class="mat-cell" [attr.colspan]="headings.length">No matching data.</td>
      </tr>
    </table>

    @if (isLoading) {
      <suvo-bi-skeleton-table-rows [rowCount]="pageSize" [columnWidths]="widths" />
    }

    <div class="table-footer">
      <app-export-with-filters
        [filtersChannel]="filtersChannel"
        [dataSourceAlias]="filtersChannel?.channelName"
        [exportFetch]="exportFetchWrapper()"
      />

      <mat-paginator
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        showFirstLastButtons
      />
    </div>
  </mat-card-content>
</mat-card>
